const sk = {
  "nav": [
    "Cenník",
    "Referencie",
    "FAQ",
    "Kontakt"
  ],
  "navCta": "Získať návrh zdarma",
  "heroBadge": "🔥 Akcia — 50% zľava len do konca mesiaca",
  "heroTitle": "Robíme weby navrhnuté na získavanie nových zákazníkov",
  "heroSub": "Moderný dizajn + SEO, aby vás zákazníci našli na Google.\nHotovo už od 3 dní.",  
  "heroBenefits": [
    "Dizajn navrhnutý tak, aby návštevníka premenil na dopyt",
    "Prvotriedna rýchlosť a bezchybné zobrazenie na mobiloch",
    "Kompletné nastavenie: Kontaktné formuláre, mapy a prepojenia",
    "Pokročilé SEO optimalizácie, aby vás klienti našli na Google",
    "Bleskové dodanie od 3 dní bez zbytočného naťahovania"
  ],
  "heroCta": "Chcem nezáväzný návrh webu zdarma",
  "navOrder": "Objednávka",
  "heroMicro": "prvý koncept do 24 hodín · úplne bez záväzkov · ukážeme vám, ako predávať viac",
  "marketTag": "🌍 Weby pre firmy na Slovensku · v Česku · v Európe",
  "marketTagShort": "🌍 Weby pre firmy na SK · v CZ · v EU",
  "problemLabel": "Kde strácate peniaze?",
  "problemTitle": "Prečo väčšina firemných webov len sedí na internete a nezarobí ani cent?",
  "problemPoints": [
    "Máte starý web, ktorý namiesto lákania klientov vašu firmu reprezentuje zle",
    "Web sa na mobile rozsype, seká alebo sa načítava príliš dlho",
    "Ľudia vás na Google vôbec nevedia nájsť — hovory a maily chodia vašej konkurencii",
    "Web vyzerá ako zo starého storočia a zákazníci vám kvôli tomu nedôverujú",
    "Agentúry od vás pýtajú tisíce eur bez akejkoľvek garancie výsledku"
  ],
  "problemClose": "Výsledok: Vaša konkurencia rastie, zatiaľ čo vy prichádzate o desiatky dopytov mesačne.",
  "agitTitle": "Každý deň so slabým webom darujete zákazníkov konkurencii",
  "agitText": "Pekný web nestačí. Ak vám web neprináša telefonáty a objednávky, sú to vyhodené peniaze. My staviame weby okolo potrieb vašich budúcich klientov.",
  "solutionLabel": "Náš proces",
  "solutionTitle": "Odoslaním formulára k novým zákazníkom od 3 dní",  
  "solutionSteps": [
    {
      "num": "01",
      "title": "Nezáväzný dopyt",
      "desc": "Zvolíte si cieľ, napíšete nám o vašom biznise a odošlete rýchly formulár."
    },
    {
      "num": "02",
      "title": "Koncept do 24 hodín",
      "desc": "Úplne zdarma vám vypracujeme úvodný vizuálny a strategický návrh riešenia."
    },
    {
      "num": "03",
      "title": "Vyladenie detailov",
      "desc": "Ak sa vám smerovanie páči, doladíme texty, štruktúru a funkcie presne podľa vás."
    },
    {
      "num": "04",
      "title": "Spustenie od 3 dní",
      "desc": "Web nasadíme na vašu doménu, nastavíme prehľad, koľko ľudí váš web navštívilo, a odovzdáme vám kľúče."
    }
  ],
  "pricingLabel": "Transparentné ceny",
  "pricingTitle": "Investujte do riešenia, ktoré sa vám rýchlo vráti",
  "pricingNote": "Žiadne skryté poplatky. Vyberte si balík, ktorý najlepšie sedí vašim aktuálnym cieľom.",
  "orderBtn": "Zvoliť tento balík a získať návrh →",
  "cards": [
    {
      "tag": "Starter",
      "badge": null,
      "name": "Web-vizitka",
      "price": "149 €",
      "old": "bežne 299 €",
      "forWhom": "Ideálne pre živnostníkov, remeselníkov a lokálne služby",
      "features": [
        "Predajný dizajn na jednej prehľadnej strane",
        "100% optimalizácia pre smartfóny a tablety",
        "Prepojenie na priamy hovor, e-mail a interaktívnu mapu",
        "Prepojenie na WhatsApp a Messenger pre okamžitý kontakt",
        "Základné nastavenie SEO pre vyhľadávanie v okolí",
        "Príprava na legislatívu a GDPR (cookies lišta)",
        "BONUS: Nastavenie / audit Google Business profilu",
        "Kompletné odovzdanie od 3 pracovných dní"
      ],
      "featured": false,
      "dark": false
    },
    {
      "tag": "Growth",
      "badge": "Najpopulárnejšie",
      "name": "Biznis web na dopyty",
      "price": "499 €",
      "old": "bežne 999 €",
      "forWhom": "Pre stabilné firmy, ktoré chcú dominovať na lokálnom trhu",
      "features": [
        "Všetko z balíka Starter +",
        "Až 5 kompletne navrhnutých podstránok (Služby, O nás...)",
        "Prehľadná galéria projektov a sekcia referencií",
        "Zistíme, čo vaši zákazníci píšu do Google, a nastavíme web tak, aby ste sa im ukázali",
        "Uvidíte, koľko ľudí vám z webu zavolalo alebo napísalo",
        "Kompletné odovzdanie do 5 pracovných dní"
      ],
      "featured": true,
      "dark": false
    },
    {
      "tag": "Performance",
      "badge": "Predajný stroj",
      "name": "Kompletný E-shop",
      "price": "999 €",
      "old": "štandardne 1 999 €",
      "forWhom": "Pre ambiciózne projekty pripravené predávať produkty online",
      "features": [
        "Všetko z balíka Biznis +",
        "Plne funkčný e-shop s kapacitou do 500 produktov",
        "Integrácia overených platobných brán (karty, Apple Pay)",
        "Automatické generovanie faktúr a prepojenie na sklad",
        "Prehľadný systém na správu objednávok a zákazníkov",
        "Kompletné odovzdanie do 14 pracovných dní"
      ],
      "featured": false,
      "dark": true
    }
  ],
  "featuredBadge": "Odporúčané",
  "reviewsLabel": "Naša práca hovorí za nás",
  "reviewsTitle": "Pozrite si výsledok nedávneho projektu",
  "riskTitle": "Spolupráca bez akéhokoľvek rizika",
  "riskText": "Veríme svojej práci, preto neriskujete ani jedno euro. Prvý koncept pripravíme na naše náklady. Vy sa rozhodnete, či budeme pokračovať.",
  "riskPoints": [
    "✓ Úvodný vizuálny návrh máte do 24 hodín úplne ZDARMA",
    "✓ Najprv podpíšeme zmluvu, zálohu platíte až keď ste s konceptom na 100% pokojní",
    "✓ Jasný plán a komunikácia bez zbytočného technického žargónu",
    "✓ Žiadne skryté poplatky ani viazanosť"
  ],
  "finalCtaTitle": "Chcete web, ktorý bude pre vašu firmu reálne zarábať?",
  "finalCtaSub": "Nečakajte, kým vás konkurencia predbehne úplne. Vyplňte formulár a zajtra máte na stole riešenie.",
  "finalCtaBtn": "Získať nezáväzný návrh riešenia →",
  "stickyCtaBtn": "Chcem web-vizitku od 149 € →",
  "formLabel": "Rýchly dopyt",
  "formTitle": "Získajte profesionálny návrh webu do 24 hodín zdarma",
  "formSub": "Napíšte nám základné detaily. Návrh je nezáväzný — ak sa vám nebude páčiť, nič neplatíte.",
  "fields": [
    {
      "key": "name",
      "label": "Vaše meno a priezvisko *",
      "type": "text",
      "placeholder": "napr. Ján Novák"
    },
    {
      "key": "email",
      "label": "Kontaktný e-mail *",
      "type": "email",
      "placeholder": "jan@firma.sk"
    },
    {
      "key": "phone",
      "label": "Telefónne číslo *",
      "type": "tel",
      "placeholder": "+421 911 111 222"
    }
  ],
  "packageLabel": "Zvolený balík *",
  "packagePlaceholder": "— Vyberte si štartovaciu pozíciu —",
  "packages": [
    "Landing page — 149 €",
    "Biznis web na dopyty — 499 €",
    "Kompletný E-shop — 999 €"
  ],
  "intentNote": "Vyberte si balík, ktorý najlepšie sedí vašim aktuálnym cieľom.",
  "intentCards": [
    {
      "value": "Landing page — 149 €",
      "intent": "Chcem len modernú vizitku",
      "sub": "Potrebujem reprezentatívnu a rýchlu stránku, aby ma klienti našli na internete.",
      "price": "149 €",
      "badge": null
    },
    {
      "value": "Biznis web na dopyty — 499 €",
      "intent": "Chcem stabilne získavať zákazníkov",
      "sub": "Potrebujem riešenie navrhnuté na generovanie dopytov, telefonátov a objednávok služieb.",
      "price": "499 €",
      "badge": "Najlepšia voľba"
    },
    {
      "value": "Kompletný E-shop — 999 €",
      "intent": "Chcem predávať produkty online",
      "sub": "Hľadám plnohodnotný, automatizovaný online obchod, ktorý zvládne celý predaj za mňa.",
      "price": "999 €",
      "badge": null
    }
  ],
  "messageLabel": "Povedzte nám niečo o vašom podnikaní (nepovinné)",
  "messagePlaceholder": "Čomu sa venujete? Čo od nového webu očakávate najviac?",
  "submitBtn": "Odoslať dopyt a získať návrh zdarma →",
  "submitting": "Pripravujem dáta...",
  "successTitle": "Skvelé, Váš dopyt sme úspešne prijali!",
  "successMsg": "Váš dopyt sme zaevidovali. Ihneď sa púšťame do analýzy a do 24 hodín vás budeme kontaktovať s hotovým návrhom.",
  "newOrder": "Nový dopyt z webu",
  "errorMsg": "❌ Systému sa nepodarilo odoslať formulár. Skúste to znova alebo nám zavolajte na číslo hore.",
  "footerRights": "© 2026 WebKlienti · Profesionálny webdizajn zameraný na výsledky",
  "faqLabel": "Odpovedáme",
  "faqTitle": "Všetko, čo potrebujete vedieť pred štartom",
  "faqItems": [
    {
      "q": "Koľko reálne trvá vytvorenie webu?",
      "a": "Sme rýchli, pretože máme zabehnutý proces. Web-vizitku vieme spustiť od 3 pracovných dní, väčšie weby trvajú dlhšie podľa rozsahu a funkcií."
    },
    {
      "q": "Budem platiť nejaké pravidelné mesačné poplatky?",
      "a": "Nie. U nás platíte len jednorazovo za kompletné zhotovenie webu. Web je po odovzdaní 100 % váš. Jediné ročné náklady sú za vašu doménu a webhosting (cca 20–30 € ročne), ktoré platíte priamo poskytovateľovi hostingu — s ich výberom a nastavením vám kompletne pomôžeme."
    },
    {
      "q": "Ako prebieha platba a kedy posielam peniaze?",
      "a": "Začiatok je úplne bezpečný. Vyplníte formulár, my spravíme analýzu a do 24 hodín vám pošleme prvý vizuálny koncept zdarma. Ak poviete 'áno, toto sa nám páči', podpíšeme zmluvu a uhradíte 50% zálohu. Zvyšných 50% platíte až vtedy, keď je web hotový, otestovaný a pripravený na spustenie."
    },
    {
      "q": "Prečo sú vaše ceny výrazne nižšie ako u klasických agentúr?",
      "a": "Neplatíme drahé kancelárie v centre mesta, manažérov ani sekretárky. Sme efektívny tím vývojárov a dizajnérov. Vyvinuli sme vlastné optimalizované postupy, vďaka ktorým dokážeme eliminovať zbytočné prestoje a dodať špičkový firemný web za zlomok bežnej ceny."
    },
    {
      "q": "Čo ak nemám žiadne texty ani profesionálne fotografie?",
      "a": "Žiadny problém, postaráme sa o to. Na základe krátkeho rozhovoru o vašom biznise napíšeme konverzné texty za vás. Pokiaľ nemáte vlastné fotky z produkcie, vyberieme licencované a vysoko profesionálne snímky z prémiových fotobánk, ktoré dokonale sadnú k vašej značke."
    },
    {
      "q": "Kto bude vlastniť hotovú webstránku?",
      "a": "Vy. Na rozdiel od iných firiem, ktoré vás uzamknú do vlastných platforiem na mesačné prenájmy, od nás dostanete plné administrátorské prístupy. Web funguje nezávisle a môžete si s ním robiť čokoľvek."
    },
    {
      "q": "Čo sa stane, ak sa mi váš prvý návrh do 24 hodín nebude páčiť?",
      "a": "Jednoducho nám poviete, čo máme zmeniť a my návrh upravíme. Ak by ste mali pocit, že sme sa úplne minuli vašej predstave, spoluprácu môžete bez akýchkoľvek otázok a poplatkov ukončiť. Keďže ste pred návrhom nič neplatili, neriskujete vôbec nič."
    }
  ],
  "guaranteeTitle": "Stopercentná garancia spokojnosti",
  "guaranteeText": "Prvý reálny koncept vášho webu vidíte skôr, než zaplatíte čo i len jedno euro.",
  "guaranteeBadges": [
    "✓ Strategická analýza trhu a návrh do 24 hodín",
    "✓ Prvý koncept úplne zadarmo a bez rizika",
    "✓ Žiadne skryté poplatky ani viazanosť"
  ],
  "cookieMsg": "Tento web používa technológie cookies na zabezpečenie správnej funkčnosti a meranie návštevnosti.",
  "cookieAccept": "Akceptovať všetko",
  "cookieDecline": "Odmietnuť",
  "privacyLink": "Zásady ochrany súkromia",
  "privacyTitle": "Spracovanie osobných údajov",
  "privacyContent": "Prevádzkovateľ: WebKlienti, info@webklienti.com, +421 907 890 600\n\nAké údaje zbierame:\n• Meno, priezvisko, e-mail, telefónne číslo — výhradne pri dobrovoľnom odoslaní dopytového formulára.\n\nNa čo ich používame:\nPríprava bezplatného návrhu, spracovanie cenovej ponuky, komunikácia so zákazníkom a plnenie zmluvných záväzkov.\n\nDoba uchovávania:\nPo dobu trvania komunikácie alebo zmluvného vzťahu a následne po dobu vyžadovanú platnými zákonmi SR.\n\nVaše práva:\nMáte plné právo na prístup k svojim údajom, ich opravu, vymazanie (právo na zabudnutie) alebo obmedzenie spracovania. Akékoľvek žiadosti posielajte na info@webklienti.com.\n\nAnalytika:\nPoužívame anonymizovaný nástroj Google Analytics na optimalizáciu chodu webu a meranie úspešnosti reklamných kampaní.\n\nPlatné od: 1.1.2025",
  "statNote": "Každý projekt staviame od prvej línie kódu pre maximálny výkon a rýchlosť. Žiadne pomalé, kupované šablóny.",
  "seoTitle": "Tvorba webstránok pre malé firmy od 149 € | WebKlienti",
  "seoDescription": "Vytvoríme vám web, vďaka ktorému vás zákazníci nájdu na Google. Hotovo už od 3 dní, návrh do 24 hodín zdarma.",
  "seoUrl": "https://www.webklienti.com",
  "heroTag": "Výkonnostný webdizajn pre malé a stredné firmy",
  "heroCtaSec": "Zobraziť cenník ↓",
  "trustStrip": [
    "Prijímame maximálne 2 nové projekty týždenne pre udržanie prémiovej kvality",
    "Čistý kód optimalizovaný pre maximálnu rýchlosť",
    "Kompletné pokrytie pre SK a CZ trh",
    "Navrhnuté s jediným cieľom: Premieňať návštevy na dopyty"
  ],
  "consentLabel": "Súhlasím so spracovaním osobných údajov za účelom vypracovania nezáväznej ponuky v súlade s",
  "consentLink": "Zásadami ochrany súkromia",
  "consentError": "Pre odoslanie dopytu musíte potvrdiť súhlas so spracovaním osobných údajov."
};

export default sk;
